/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationscurexaCurexaIntegration1 from './IntegrationscurexaCurexaIntegration1';

/**
 * The IntegrationsCurexaBody1 model module.
 * @module model/IntegrationsCurexaBody1
 * @version v0.3
 */
export default class IntegrationsCurexaBody1 {
  /**
   * Constructs a new <code>IntegrationsCurexaBody1</code>.
   * @alias module:model/IntegrationsCurexaBody1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsCurexaBody1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsCurexaBody1} obj Optional instance to populate.
   * @return {module:model/IntegrationsCurexaBody1} The populated <code>IntegrationsCurexaBody1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsCurexaBody1();
      if (data.hasOwnProperty('curexa_integration'))
        obj.curexaIntegration = IntegrationscurexaCurexaIntegration1.constructFromObject(data['curexa_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationscurexaCurexaIntegration1} curexaIntegration
 */
IntegrationsCurexaBody1.prototype.curexaIntegration = undefined;

